"use strict";

/**
 * Предоставляет инструменты для работы с Агентом веб-доступа.
 * Например, запустить или отключить Агент веб-доступа.
 *
 * @namespace WebAccess.agent
 * @since 5.0.0.4100
 */
(function (global) {
  var Agent = BaseObject.extend([AgentSession], {
    _availablePlugins: {},
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function () {
      this._availablePlugins = {};
    },

    /**
    * Проверяет, включен ли запрет на использование и запуск Агента веб-доступа.
    *
    * @method WebAccess.agent.isDisabled
    * @return {boolean} True – запрет на использование и запуск Агент веб-доступа включен, иначе False.
    * @since 5.1.0.1511
    */
    isDisabled: function () {
      var isDisabledValue = WA.cache.getItem('agent.isDisabled');
      $.cookie('IsAgentDisabled', isDisabledValue, { expires: 3650 });
      return isDisabledValue === '1';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включает запрет на использование и запуск Агента веб-доступа.
    *
    * @method WebAccess.agent.disable
    * @return {WebAccess.agent} Объект типа agent.
    * @since 5.1.0.1511
    */
    disable: function () {
      log.warning('AGENT', 'Agent was manualy disabled');
      WA.cache.setItem('agent.isDisabled', '1');
      $.cookie('IsAgentDisabled', '1', { expires: 3650 });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отключает запрет на использование и запуск Агента веб-доступа.
    *
    * @method WebAccess.agent.enable
    * @return {WebAccess.agent} Объект типа agent.
    * @since 5.1.0.1511
    */
    enable: function () {
      log.info('AGENT', 'Agent was manualy enabled');
      WA.cache.setItem('agent.isDisabled', '0');
      $.cookie('IsAgentDisabled', '0', { expires: 3650 });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Определяет, сохранено ли в кэше значение о запрете на использование и запуск Агента веб-доступа.
    *
    * @method WebAccess.agent.isDisableSetted
    * @return {boolean} True – значение в кэше сохранено, иначе False.
    * @since 5.4.0.1037
    */
    isDisableSetted: function () {
      return WA.cache.getItem('agent.isDisabled') !== null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверяет, доступен ли Агент веб-доступа.
    *
    * @method WebAccess.agent.isAvailable
    * @return {boolean} True – Агент веб-доступа доступен для работы, иначе False.
    *
    * @example
    * if (WebAccess.agent.isAvailable()) {
    *  alert('На текущем компьютере Агент веб-доступа установлен и доступен для работы.');
    * };
    */
    isAvailable: function () {
      return this.canUseInCurrentDevice() && !this.isDisabled();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверяет, возможно ли использование Агента веб-доступа на данном устройстве.
    *
    * @method WebAccess.agent.canUseInCurrentDevice
    * @return {boolean} True – использование Агента веб-доступа возможно, иначе False.
    *
    * @example
    * if (WebAccess.agent.canUseInCurrentDevice()) {
    *  alert('Использование Агента веб-доступа на данном устройстве возможно.');
    * };
    */
    canUseInCurrentDevice: function () {
      var isARM = WA.ENV.ua.toLowerCase().search(/arm/) >= 0;      
      var isBlackberry = WA.ENV.os.name === "BlackBerry";
      return !WA.ENV.isAndroid() && !WA.ENV.isIOS() && !isARM && !isBlackberry;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Проверяет, что сессия Агента веб-доступа инициализирована.
    *
    * @method WebAccess.agent.isSessionInitialized
    * @return {boolean} True – сессия Агента веб-доступа инициализирована, иначе False.
    * @since 5.1.0.1511
    */
    isSessionInitialized: function () {
      return $.cookie('IsAgentSessionInitialized') === '1';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Устанавливает признак инициализации сессии Агента веб-доступа.
    *
    * @param {Boolean} value Устанавливаемое значение
    * @method WebAccess.agent.setSessionInitialized
    * @return {WebAccess.agent} Объект типа agent.
    * @since 5.1.0.1511
    */
    setSessionInitialized: function (value) {
      log.info('AGENT', 'Setting IsAgentSessionInitialized cookie with value: ' + value);
      $.cookie('IsAgentSessionInitialized', value ? '1' : '0');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отображает состояние агента.
    * @method WebAccess.agent._showState
    * @return {WebAccess.agent}
    * @since 5.1.0.1532
    * @private
    */
    _showState: function () {
      log.debug('AGENT', '------------ AGENT STATE --------------');
      log.debug('AGENT', 'web.config enabled: ' + g_IsAgentEnabled);
      log.debug('AGENT', 'isDisabled: ' + WA.agent.isDisabled());
      log.debug('AGENT', 'isSessionInitialized: ' + WA.agent.isSessionInitialized());
      log.debug('AGENT', '---------------- END -----------------');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверяет, доступен ли плагин Агента веб-доступа.
     * @method WebAccess.agent#isPluginAvailable
     * @param {string} pluginName Имя плагина
     * @return {promise} Объект Promise, в котором True – плагин Агента веб-доступа доступен для работы, иначе False.
     *
     * @example
     * WebAccess.agent.isPluginAvailable('edmsplugin').done(function(res){
     *   if (res)
     *     alert('Плагин Агента веб-доступа доступен для работы с EDMS-объектами системы DIRECTUM');
     * });
     */
    isPluginAvailable: function (pluginName) {
      var d = $.Deferred();

      var me = this;
      var params = {
        'name': pluginName
      };

      if (typeof me._availablePlugins[pluginName] !== 'undefined') {
        d.resolve(me._availablePlugins[pluginName]);
        return d.promise();
      }

      //Шамов А.: Если тут проверять запущен или нет, то тогда мы не покажем диалог "Подождать еще", т.к. он будет не запущен и ВД будет работать без него. Например, в быстрых действиях.
      if (me.isAvailable()) {
        me.transmitRequest('IsPluginAvailable', '', params)
          .done(function (response) {
            var booleanResult = (response.result === "true");
            me._availablePlugins[pluginName] = booleanResult;
            d.resolve(booleanResult);
          })
          .fail(function (response) {
            me._availablePlugins[pluginName] = false;
            d.reject(false);
          });
      } else {
        me._availablePlugins[pluginName] = false;
        d.reject(false);
      }

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отправляет запрос Агенту веб-доступа, используя доступный транспорт.
     * Транспорт – это один из механизмов для взаимодействия с Агентом веб-доступа. Например, NPAPI-транспорт или HTTP-транспорт.
     *
     * @method WebAccess.agent.transmitRequest
     * @param  {string} requestName Имя запроса
     * @param  {string} pluginName Имя плагина Агента, к которому идет обращение.
     * Для базовых вызовов к ядру Агента веб-доступа передается пустая строка
     * @param  {object} params Параметры запроса
     * @param  {object} extraParams Дополнительные параметры запроса (например, timeout)
     * @return {promise} Объект Promise, внутри которого object - результат запроса.
     *
     * @example
     * WebAccess.agent.transmitRequest('PING','',{}).done(function(response){
     *   console.log(response) //  Object { message="PONG", success=true}
     * });
     */
    transmitRequest: function (requestName, pluginName, params, extraParams) {
      var me = this;

      var d = $.Deferred();

      log.info('AGENT', '"transmitRequest" method "' + requestName + '" was called');

      if (me.isDisabled()) {
        log.info('AGENT', 'Agent disabled');
        d.reject({ message: null, success: false });
      }

      global.agent.transport.transmitRequest(requestName, pluginName, params, extraParams).always(function (respObj) {
        log.info('AGENT', 'Response of "transmitRequest" method "' + requestName + '": ', $.toJSON(respObj));
      }).done(function (respObj) {
        d.resolve(respObj);
      }).fail(function (respObj) {
        d.reject(respObj);
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Окно отображаемое при потере связи с агентом.
    * @method WebAccess.agent._showWaitMoreDialog
    * @since 5.1.0.1511
    * @private
    * @return WebAccess.agent
    */
    _showWaitMoreDialog: function () {
      var me = this;

      if (!!me._showWaitMoreDialogTimeout) clearTimeout(me._showWaitMoreDialogTimeout);
      me._showWaitMoreDialogTimeout = setTimeout(function () {

        var isAgentStartedAfterWait = false;

        var cancelClickAndOnClose = function () {
          if (!isAgentStartedAfterWait) {
            WA.agent.disable();
            window.location.reload();
          }
        };

        var d = new WA.CMP.dialogs.MessageBox();
        d.id = 'waitMore';
        //d.isSingleInstance = true;
        d.width = 450;
        d.okCancelButtons(function okClick() {
          d.disableButton('modal_ok_button');
          d.inlineHint.showWarning(L('AGENT_WAITING_START'));
          $('#errIcon').find('span').css({ 'background': 'url("images/spinner.gif")' });

          global.agent.transport.waitForStart(60000).done(function () {
            log.info('AGENT', 'Waiting for agnent is done');
            // Всё же дождались старта.
            isAgentStartedAfterWait = true;
            d.close();
          }).fail(function (reason) {
            log.info('AGENT', 'Waiting for agnent is failed');

            d.enableButton('modal_ok_button');
            // Не дождались.
            d.inlineHint.show(L('AGENT_WAITING_START_FAIL'));
          });

          return false;
        }, cancelClickAndOnClose);
        d.okText = L('WAIT_AGENT');
        d.cancelText = L('CONTINUE_WITHOUT_AGENT');
        d.show(L('AGENT_NOT_RESPONSE_WAIT_MORE'), L('AGENT_NOT_RESPONSE_WAIT_MORE_ADDITIONAL_TEXT'), L('ERROR'), 'error', null, cancelClickAndOnClose);

        log.info('AGENT', 'WaitMoreDialog was shown');

      }, 400);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _showWaitMoreDialogTimeout: null,

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Окно отображаемое при обращении к агенту в другой сессии ОС.
    * @method WebAccess.agent._showAgentStartedInAnotherSessionDialog
    * @since 5.1.0.1511
    * @private
    */
    _showAgentStartedInAnotherSessionDialog: function () {
      var me = this;
      var d = new WA.CMP.dialogs.MessageBox();
      d.id = 'anotherSessionError';
      d.isSingleInstance = true;
      d.okText = L('CONTINUE_WITHOUT_AGENT');
      d.show(L('AGENT_RUNNING_IN_AHOTHER_WINDOWS_SESSION'), L('AGENT_RUNNING_IN_AHOTHER_WINDOWS_SESSION_ADDITIONAL_TEXT'), L('ERROR'), 'error', null, function () {
        WA.agent.disable();
        window.location.reload();
      });
      log.info('AGENT', 'AgentStartedInAnotherSessionDialog was shown');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Метод вызывается при потере соединения, когда агент изначально был
    * запущен, но не отвечает, перезапускаем его.
    * @private
    * @since 5.1.0.1505
    */
    _onConnectionLost: function () {
      var me = this;
      log.info('AGENT', 'Connection lost. Trying start agent again');
      WA.agent.start(true).done(function startDone(isRegistered) {
        afterStartAgent();
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Запускает Агент веб-доступа.
    *
    * @method WebAccess.agent.start
    * @param {Boolean} [opt_force] Принудительный запуск Агента веб-доступа. Запуск выполняется при любых условиях.
    * @return {Deferred} Специальный deferred-объект.
    * @since 5.1.0.1500
    */
    start: function (opt_force) {
      this._availablePlugins = {};
      return global.agent.transport.start(opt_force);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Останавливает работу Агента веб-доступа.
     * Используется для повторного соединения веб-страницы с Агентом веб-доступа.
     *
     * @method WebAccess.agent.stop
     * @return {WebAccess.agent} Объект типа agent.
     */
    stop: function () {
      this._availablePlugins = {};
      global.agent.transport.stop();
      return global.agent;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Перезапускает Агент веб-доступа.
    *
    * @method WebAccess.agent.restart
    * @return {WebAccess.agent} Объект типа agent.
    */
    restart: function () {
      this._availablePlugins = {};
      return global.agent.transport.restart();
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отменяет запуск Агента веб-доступа.
    *
    * @method WebAccess.agent.cancelStart
    * @return {WebAccess.agent} Объект типа agent.
    */
    cancelStart: function () {
      this._availablePlugins = {};
      global.agent.transport.cancelStart();
      return this;
    },

    /**
    * Скачивает Агент веб-доступа.
    *
    * @method WebAccess.agent.download
    * @return {$.Deferred} Отложенный объект с результатом запуска.
    */
    download: function (packageName) {
      var def = $.Deferred();

      if (!packageName) {
        var platform = WA.ENV.platform;
        var os = WA.ENV.os.name.toLowerCase();

        if (platform === 'linux') {
          if (os === 'mint' || os === 'ubuntu' || os === 'debian') {
            packageName = platform + '_deb';
          } else {
            packageName = platform + '_rpm';
          }
        } else {
          packageName = platform;
        }
      }

      if (g_AgentInstallID[packageName]) {
        window.open('/Download.ashx?accesstype=0&id=' + g_AgentInstallID[packageName]);
        def.resolve(packageName);
      } else {
        def.reject();
      }

      return def;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверяет, запущен ли Агент веб-доступа. Делает attemptNumber попыток.
    *
    * @method WebAccess.agent.checkSessionState
    * @param {integer} attemptNumber Количество попыток
    * @return {$.Deferred} Отложенный объект с результатом запуска.
    */
    checkSessionState: function (attemptNumber) {
      attemptNumber = typeof attemptNumber !== 'undefinded' ? attemptNumber : 1;
      return this._checkSessionStateLoop($.Deferred(), 0, attemptNumber);
    },

    // Проверяет запущен ли агент. Делает несколько попыток.
    _checkSessionStateLoop: function (def, attemptIndex, maxAttemptNumber) {
      var me = this;
      // Если агент не запущен, то сам transmitRequest будет по таймауту висеть.
      me.transmitRequest("GetSessionRegistrationStatus", "", { "SessionID": window.g_UserContextID || '' }).done(function (pingResponse) {
        if (pingResponse.result === 'REGISTERED') {
          log.info('AGENT', 'Session successfully registered by agent');
          def.resolve(true);
        } else if (pingResponse.result === 'NOTREGISTERED') {
          log.info('AGENT', 'Session registration rejected by agent');
          def.resolve(false);
          WA.agent._showAgentStartedInAnotherSessionDialog();
        }
      }).fail(function (pingResponse) {
        if (pingResponse.result === "ERR_INVALID_SESSION_ID") {
          def.reject(true);
        } else {
          if (attemptIndex < maxAttemptNumber) {
            me._checkSessionStateLoop(def, attemptIndex + 1);
          } else {
            def.reject();
          }
        }
      });

      return def;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
   * Очищает кэш доступных плагинов Агента веб-доступа.
   *
   * @method WebAccess.agent.clearPluginCache
   */
    clearPluginCache: function () {
      this._availablePlugins = {};
    },

    /**
    * Выгружает логи агента на сервер веб-доступа.
    *
    * @method WebAccess.agent.uploadLogs   
    */
    uploadLogs: function () {
      var me = this;
      var d = $.Deferred();

      var params = {
        "IsSecured": (document.location.protocol === 'http:' ? 'n' : 'y'),
        "Host": document.location.host,
        "ClientAffinity": ($.cookie('ARRAffinity') == null ? '' : $.cookie('ARRAffinity'))
      };

      //Получаем токен на запрос уведомлений о новых заданиях
      WA.SRV.call("/Security.asmx/GetOpToken0", { Operation: TOKEN_OPERATION.DIAGNOSTICS }).done(function (token) {
          params["Token"] = token;

          me.transmitRequest("GetLogs", "", params).done(function (response) {
            if (response.success === true) {
                  d.resolve(response);
              } else {
                  d.reject(response);
              };
          }).fail(function (response) {
              d.reject(response);
          });
      });

      return d.promise();
    }
  });

  global.agent = new Agent();
  global.agent.Agent = Agent;
})(window.WebAccess);
